var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoviesMusic = function SvgMoviesMusic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.5 11.5 8 6 4.5zM8.006 16a7.8 7.8 0 0 1-3.11-.625 8.1 8.1 0 0 1-2.552-1.719 8.1 8.1 0 0 1-1.719-2.551A7.8 7.8 0 0 1 0 7.99q0-1.657.625-3.105a8.066 8.066 0 0 1 4.27-4.26A7.8 7.8 0 0 1 8.01 0a7.75 7.75 0 0 1 3.105.625q1.447.626 2.541 1.719a8.1 8.1 0 0 1 1.719 2.546A7.8 7.8 0 0 1 16 7.994a7.8 7.8 0 0 1-.625 3.11 8.1 8.1 0 0 1-1.719 2.552 8.1 8.1 0 0 1-2.546 1.719A7.8 7.8 0 0 1 8.006 16M8 14.5q2.709 0 4.604-1.896T14.5 8t-1.896-4.604T8 1.5 3.396 3.396 1.5 8t1.896 4.604T8 14.5"
  })));
};
export default SvgMoviesMusic;